import { defineMessages } from 'react-intl';

export default defineMessages({

  relationshipToYou: {
    id: 'fastCover.medicalExpenseZurichStep.relationshipToYou',
    defaultMessage: "Claimant's Relationship to you",
  },

  nationalIdOrVisa: {
    id: 'fastCover.medicalExpenseZurichStep.nationalIdOrVisa',
    defaultMessage: 'National ID or Visa #',
  },

  ifYesPleaseProvide: {
    id: 'fastCover.medicalExpenseZurichStep.ifYesPleaseProvide',
    defaultMessage: "If yes, please provide the carrier's name, address and policy insurance:",
  },

  nationalId: {
    id: 'fastCover.medicalExpenseZurichStep.nationalId',
    defaultMessage: 'National ID',
  },

  visa: {
    id: 'fastCover.medicalExpenseZurichStep.visa',
    defaultMessage: 'Visa #',
  },

  id: {
    id: 'fastCover.medicalExpenseZurichStep.id',
    defaultMessage: 'ID #',
  },

  purposeOfTrip: {
    id: 'fastCover.medicalExpenseZurichStep.purposeOfTrip',
    defaultMessage: 'Purpose of Trip',
  },

  holiday: {
    id: 'fastCover.medicalExpenseZurichStep.holiday',
    defaultMessage: 'Holiday',
  },

  business: {
    id: 'fastCover.medicalExpenseZurichStep.business',
    defaultMessage: 'Business',
  },

  medical: {
    id: 'fastCover.medicalExpenseZurichStep.medical',
    defaultMessage: 'Medical',
  },

  other: {
    id: 'fastCover.medicalExpenseZurichStep.other',
    defaultMessage: 'Other',
  },

  ifOtherPleaseDescribe: {
    id: 'fastCover.medicalExpenseZurichStep.ifOtherPleaseDescribe',
    defaultMessage: 'If other, please describe',
  },

  didYouContactAssistanceCompany: {
    id: 'fastCover.medicalExpenseZurichStep.didYouContactAssistanceCompany',
    defaultMessage: 'Did you contact our Assistance Company?',
  },

  assistanceCaseReferenceNumberFileNumber: {
    id: 'fastCover.medicalExpenseZurichStep.assistanceCaseReferenceNumberFileNumber',
    defaultMessage: 'Assistance Case Reference Number / File Number',
  },

  didYouHaveOtherMedicalInsurance: {
    id: 'fastCover.medicalExpenseZurichStep.didYouHaveOtherMedicalInsurance',
    defaultMessage: 'Did you have other medical insurance?',
  },

  insuranceCarriersName: {
    id: 'fastCover.medicalExpenseZurichStep.insuranceCarriersName',
    defaultMessage: "Insurance Carrier's Name",
  },

  address: {
    id: 'fastCover.medicalExpenseZurichStep.address',
    defaultMessage: 'Address',
  },

  cityOrTown: {
    id: 'fastCover.medicalExpenseZurichStep.cityOrTown',
    defaultMessage: 'City or Town',
  },

  country: {
    id: 'fastCover.medicalExpenseZurichStep.country',
    defaultMessage: 'Country',
  },

  postalCode: {
    id: 'fastCover.medicalExpenseZurichStep.postalCode',
    defaultMessage: 'Postal Code',
  },

  policyId: {
    id: 'fastCover.medicalExpenseZurichStep.policyId',
    defaultMessage: 'Policy ID',
  },

  policyHolder: {
    id: 'fastCover.medicalExpenseZurichStep.policyHolder',
    defaultMessage: 'Policy Holder',
  },

  contact: {
    id: 'fastCover.medicalExpenseZurichStep.contact',
    defaultMessage: 'Contact',
  },

  email: {
    id: 'fastCover.medicalExpenseZurichStep.email',
    defaultMessage: 'Email',
  },

  phoneNumber: {
    id: 'fastCover.medicalExpenseZurichStep.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  areYouACitizenOfTheEuropeanUnion: {
    id: 'fastCover.medicalExpenseZurichStep.areYouACitizenOfTheEuropeanUnion',
    defaultMessage: 'Are you a citizen of the European Union?',
  },

  forEUCitizens: {
    id: 'fastCover.medicalExpenseZurichStep.forEUCitizens',
    defaultMessage: 'Was a European Health Insurance Card (EHIC) taken on this trip?',
  },

  ifYesWasTheEHIC: {
    id: 'fastCover.medicalExpenseZurichStep.ifYesWasTheEHIC',
    defaultMessage: 'If yes, was the EHIC presented to the hospital or physician?',
  },

  hospitalAndMedicalExpenses: {
    id: 'fastCover.medicalExpenseZurichStep.hospitalAndMedicalExpenses',
    defaultMessage: 'HOSPITAL & MEDICAL EXPENSES (Including prescriptions, x-rays, doctor visits, etc.)',
  },

  accidentStartDate: {
    id: 'fastCover.medicalExpenseZurichStep.accidentStartDate',
    defaultMessage: 'Accident/Illness Start Date',
  },

  accidentStartDateForIllness: {
    id: 'fastCover.medicalExpenseZurichStep.accidentStartDate',
    defaultMessage: 'Illness Start Date',
  },

  accidentFirstTreatment: {
    id: 'fastCover.medicalExpenseZurichStep.accidentFirstTreatment',
    defaultMessage: 'Accident/Illness First Treatment',
  },

  nameOfPhysicianFacilityFirstContacted: {
    id: 'fastCover.medicalExpenseZurichStep.nameOfPhysicianFacilityFirstContacted',
    defaultMessage: 'Name of Physician/Facility first contacted',
  },

  ifNoPleaseExplain: {
    id: 'fastCover.medicalExpenseZurichStep.ifNoPleaseExplain',
    defaultMessage: 'If no, please explain',
  },

  isTheClaimTheResultOfAniLLness: {
    id: 'fastCover.medicalExpenseZurichStep.isTheClaimTheResultOfAnIllness',
    defaultMessage: 'Is the claim the result of an Illness?',
  },

  symptoms: {
    id: 'fastCover.medicalExpenseZurichStep.symptoms',
    defaultMessage: 'Symptoms',
  },

  details: {
    id: 'fastCover.medicalExpenseZurichStep.details',
    defaultMessage: 'Details',
  },

  isTheClaimTheResultOfAccidentOrInjury: {
    id: 'fastCover.medicalExpenseZurichStep.isTheClaimTheResultOfAccidentOrInjury',
    defaultMessage: 'Is the claim the result of accident or injury?',
  },

  place: {
    id: 'fastCover.medicalExpenseZurichStep.place',
    defaultMessage: 'Place',
  },

  accidentDate: {
    id: 'fastCover.medicalExpenseZurichStep.accidentDate',
    defaultMessage: 'Accident Date',
  },

  accidentTime: {
    id: 'fastCover.medicalExpenseZurichStep.accidentTime',
    defaultMessage: 'Accident Time',
  },

  treatingPhysicianFacility: {
    id: 'fastCover.medicalExpenseZurichStep.treatingPhysicianFacility',
    defaultMessage: 'Treating Physician/Facility',
  },

  treatingPhysicianFacilityFirstContacted: {
    id: 'fastCover.medicalExpenseZurichStep.treatingPhysicianFacility',
    defaultMessage: 'Treating Physician/Facility',
  },

  phoneNumberForPhysician: {
    id: 'fastCover.medicalExpenseZurichStep.phoneNumberForPhysician',
    defaultMessage: 'Physician/Facility Phone Number',
  },

  ifPriorTreatmentWasGivenIn: {
    id: 'fastCover.medicalExpenseZurichStep.ifPriorTreatmentWasGivenIn',
    defaultMessage: 'If prior treatment was given in a hospital, as an inpatient, please provide',
  },

  facilityName: {
    id: 'fastCover.medicalExpenseZurichStep.facilityName',
    defaultMessage: 'Facility Name',
  },

  admitDate: {
    id: 'fastCover.medicalExpenseZurichStep.admitDate',
    defaultMessage: 'Admit Date',
  },

  timeOfAdmission: {
    id: 'fastCover.medicalExpenseZurichStep.timeOfAdmission',
    defaultMessage: 'Time of Admission',
  },

  dischargeDate: {
    id: 'fastCover.medicalExpenseZurichStep.dischargeDate',
    defaultMessage: 'Discharge Date',
  },

  timeOfDischarge: {
    id: 'fastCover.medicalExpenseZurichStep.timeOfDischarge',
    defaultMessage: 'Time of Discharge',
  },

  expensesClaimed: {
    id: 'fastCover.medicalExpenseZurichStep.expensesClaimed',
    defaultMessage: 'Expenses Claimed',
  },

  currency: {
    id: 'fastCover.medicalExpenseZurichStep.currency',
    defaultMessage: 'Currency',
  },

  didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness: {
    id: 'fastCover.medicalExpenseZurichStep.didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness',
    defaultMessage: 'Did any physician prohibit you from traveling by air or otherwise due to this injury/Illness?',
  },

  wereYouTravelingToReceiveMedicalTreatment: {
    id: 'fastCover.medicalExpenseZurichStep.wereYouTravelingToReceiveMedicalTreatment',
    defaultMessage: 'Were you traveling to receive medical treatment?',
  },

  alternativeTreatment: {
    id: 'fastCover.medicalExpenseZurichStep.alternativeTreatment',
    defaultMessage: 'Alternative Treatment',
  },

  ifYesWhenDidYouLearnOfTheAlternativeTreatment: {
    id: 'fastCover.medicalExpenseZurichStep.ifYesWhenDidYouLearnOfTheAlternativeTreatment',
    defaultMessage: 'If yes, when did you learn of the alternative treatment?',
  },

  whoRecommendedTheTreatment: {
    id: 'fastCover.medicalExpenseZurichStep.whoRecommendedTheTreatment',
    defaultMessage: 'Who recommended the treatment?',
  },

  areYouPregnant: {
    id: 'fastCover.medicalExpenseZurichStep.areYouPregnant',
    defaultMessage: 'Are you pregnant?',
  },

  ifYesNumberOfWeeks: {
    id: 'fastCover.medicalExpenseZurichStep.ifYesNumberOfWeeks',
    defaultMessage: 'If yes, number of weeks',
  },

  yes: {
    id: 'fastCover.medicalExpenseZurichStep.yes',
    defaultMessage: 'Yes',
  },

  no: {
    id: 'fastCover.medicalExpenseZurichStep.no',
    defaultMessage: 'No',
  },
  //---------------------------
  areYouClaimingForDamagedLostOrStolenLuggage: {
    id: 'fastCover.stepBaggageAndPersonalItems.areYouClaimingForDamagedLostOrStolenLuggage',
    defaultMessage: 'Are you claiming for Damaged, Lost, or Stolen Luggage?',
  },

  areYouClaimingForBaggageDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.areYouClaimingForBaggageDelay',
    defaultMessage: 'Are you claiming for Baggage Delay?',
  },

  areYouClaimingFor: {
    id: 'fastCover.stepBaggageAndPersonalItems.areYouClaimingFor',
    defaultMessage: 'Are you claiming for:',
  },

  travelSupplierProviderInformation: {
    id: 'fastCover.stepBaggageAndPersonalItems.travelSupplierProviderInformation',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  companyYouWereTravelingWith: {
    id: 'fastCover.stepBaggageAndPersonalItems.companyYouWereTravelingWith',
    defaultMessage: 'Company you were traveling with:',
  },

  origin: {
    id: 'fastCover.stepBaggageAndPersonalItems.origin',
    defaultMessage: 'Origin',
  },

  flightNumber: {
    id: 'fastCover.stepBaggageAndPersonalItems.flightNumber',
    defaultMessage: 'Flight Number',
  },

  airCarrier: {
    id: 'fastCover.stepBaggageAndPersonalItems.airCarrier',
    defaultMessage: 'Air Carrier',
  },

  destination: {
    id: 'fastCover.stepBaggageAndPersonalItems.destination',
    defaultMessage: 'Destination',
  },

  lossInformation: {
    id: 'fastCover.stepBaggageAndPersonalItems.lossInformation',
    defaultMessage: 'Loss Information',
  },

  dateOfLoss: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateOfLoss',
    defaultMessage: 'Date of Loss',
  },

  pleaseDescribeWhatOccurred: {
    id: 'fastCover.stepBaggageAndPersonalItems.pleaseDescribeWhatOccurred',
    defaultMessage: 'Please describe what occurred',
  },

  whoDidYouReportTo: {
    id: 'fastCover.stepBaggageAndPersonalItems.whoDidYouReportTo',
    defaultMessage: 'Who did you report to?',
  },

  reportReferenceNumber: {
    id: 'fastCover.stepBaggageAndPersonalItems.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },

  nameAndAddress: {
    id: 'fastCover.stepBaggageAndPersonalItems.nameAndAddress',
    defaultMessage: 'Name and Address',
  },

  nameCustomerServiceDepartment: {
    id: 'fastCover.stepBaggageAndPersonalItems.nameCustomerServiceDepartment',
    defaultMessage: 'Name (Customer Service Department)',
  },

  doYouHaveAnyFurtherDetailsToAdd: {
    id: 'fastCover.stepBaggageAndPersonalItems.doYouHaveAnyFurtherDetailsToAdd',
    defaultMessage: 'Do you have any further details to add',
  },

  loss: {
    id: 'fastCover.stepBaggageAndPersonalItems.loss',
    defaultMessage: 'Loss',
  },

  theft: {
    id: 'fastCover.stepBaggageAndPersonalItems.theft',
    defaultMessage: 'Theft',
  },

  damage: {
    id: 'fastCover.stepBaggageAndPersonalItems.damage',
    defaultMessage: 'Damage',
  },

  tourOperator: {
    id: 'fastCover.stepBaggageAndPersonalItems.tourOperator',
    defaultMessage: 'Tour Operator',
  },

  cruiseLine: {
    id: 'fastCover.stepBaggageAndPersonalItems.cruiseLine',
    defaultMessage: 'Cruise Line',
  },

  airline: {
    id: 'fastCover.stepBaggageAndPersonalItems.airline',
    defaultMessage: 'Airline',
  },

  airport: {
    id: 'fastCover.stepBaggageAndPersonalItems.airport',
    defaultMessage: 'Airport',
  },

  hotel: {
    id: 'fastCover.stepBaggageAndPersonalItems.hotel',
    defaultMessage: 'Hotel',
  },

  rentalAgency: {
    id: 'fastCover.stepBaggageAndPersonalItems.rentalAgency',
    defaultMessage: 'Rental Agency',
  },

  police: {
    id: 'fastCover.stepBaggageAndPersonalItems.police',
    defaultMessage: 'Police',
  },

  hospitalManagement: {
    id: 'fastCover.stepBaggageAndPersonalItems.hospitalManagement',
    defaultMessage: 'Hospital Management',
  },

  cruiseShip: {
    id: 'fastCover.stepBaggageAndPersonalItems.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },

  tourGuide: {
    id: 'fastCover.stepBaggageAndPersonalItems.tourGuide',
    defaultMessage: 'Tour Guide',
  },

  notReported: {
    id: 'fastCover.stepBaggageAndPersonalItems.notReported',
    defaultMessage: 'Not Reported',
  },

  addItem: {
    id: 'fastCover.stepBaggageAndPersonalItems.addItem',
    defaultMessage: 'Add Item',
  },

  itemWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItems.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },

  item: {
    id: 'fastCover.stepBaggageAndPersonalItems.item',
    defaultMessage: 'Item',
  },

  estimatedValue: {
    id: 'fastCover.stepBaggageAndPersonalItems.estimatedValue',
    defaultMessage: 'Estimated Value',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.stepBaggageAndPersonalItems.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received Reimbursement?',
  },

  fromWhom: {
    id: 'fastCover.stepBaggageAndPersonalItems.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  howMuch: {
    id: 'fastCover.stepBaggageAndPersonalItems.howMuch',
    defaultMessage: 'How much?',
  },

  totalExpensesClaimed: {
    id: 'fastCover.stepBaggageAndPersonalItems.totalExpensesClaimed',
    defaultMessage: 'Total Expenses Claimed',
  },

  addPrescriptionMedicines: {
    id: 'fastCover.stepBaggageAndPersonalItems.addPrescriptionMedicines',
    defaultMessage: 'Add Prescription medicine',
  },

  prescriptionMedicinesV1: {
    id: 'fastCover.stepBaggageAndPersonalItems.prescriptionMedicinesV1',
    defaultMessage: 'Prescription medicines you have been prescribed for your injury or illness',
  },

  dosage: {
    id: 'fastCover.stepBaggageAndPersonalItems.dosage',
    defaultMessage: 'Dosage',
  },

  nameOfPrescribingDoctor: {
    id: 'fastCover.stepBaggageAndPersonalItems.nameOfPrescribingDoctor',
    defaultMessage: 'Name of Prescribing Doctor',
  },

  prescriptionMedicinesV2: {
    id: 'fastCover.stepBaggageAndPersonalItems.prescriptionMedicinesYouHave',
    defaultMessage: 'Prescription medicines, herbal medications or vitamins you took prior to your effective date that are not related to your injury/illness',
  },

  changeTo: {
    id: 'fastCover.stepBaggageAndPersonalItems.changeTo',
    defaultMessage: 'Is this a claim due to an unexpected recurrence or a pre-existing condition?',
  },

  ifYesNameOfPhysicianCurrentlyTreatingThis: {
    id: 'fastCover.stepBaggageAndPersonalItems.ifYesNameOfPhysicianCurrentlyTreatingThis',
    defaultMessage: 'If yes, name of physician currently treating this',
  },

  // ------------------------------------------------------------------------------------

  tripCancellation: {
    id: 'fastCover.stepBaggageAndPersonalItems.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  travelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.travelInterruption',
    defaultMessage: 'Are you claiming for Travel Interruption?',
  },

  travelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons2',
    defaultMessage: 'You Unforeseen Sickness or Injury or, the Sickness or Injury if a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity a Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country',
  },

  reasons4: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons4',
    defaultMessage: 'or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  travelSupplier: {
    id: 'fastCover.stepBaggageAndPersonalItems.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  addressTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  phoneNumberTravelInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.phoneNumberTravelInterruption',
    defaultMessage: 'Phone Number',
  },

  includedInPackage: {
    id: 'fastCover.stepBaggageAndPersonalItems.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  addLossInformation: {
    id: 'fastCover.stepBaggageAndPersonalItems.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItems.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.stepBaggageAndPersonalItems.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.stepBaggageAndPersonalItems.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateEnded: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.stepBaggageAndPersonalItems.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.stepBaggageAndPersonalItems.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },

  companyNameLoss: {
    id: 'fastCover.stepBaggageAndPersonalItems.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruse/travel agent/ect.)',
  },

  amountPaidLoss: {
    id: 'fastCover.stepBaggageAndPersonalItems.amountPaidLoss',
    defaultMessage: 'Amount Paid (total for all insureds)',
  },

  amountOfLoss: {
    id: 'fastCover.stepBaggageAndPersonalItems.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.stepBaggageAndPersonalItems.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  reasonsForDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident en router to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateOfInitialPaymentDeposit: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.stepBaggageAndPersonalItems.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateDelayEnded: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.stepBaggageAndPersonalItems.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayInformation',
    defaultMessage: 'Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.stepBaggageAndPersonalItems.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.stepBaggageAndPersonalItems.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.stepBaggageAndPersonalItems.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepBaggageAndPersonalItems.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  delay: {
    id: 'fastCover.stepBaggageAndPersonalItems.delay',
    defaultMessage: 'Delay',
  },
  hotelManagement: {
    id: 'fastCover.stepBaggageAndPersonalItems.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  otherDescription: {
    id: 'fastCover.stepBaggageAndPersonalItems.otherDescription',
    defaultMessage: 'If yes, please describe',
  },
  descriptionOfItems: {
    id: 'fastCover.stepBaggageAndPersonalItems.descriptionOfItems',
    defaultMessage: 'Description of items',
  },
  datePurchased: {
    id: 'fastCover.stepBaggageAndPersonalItems.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.stepBaggageAndPersonalItems.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.stepBaggageAndPersonalItems.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  amountClaimed: {
    id: 'fastCover.stepBaggageAndPersonalItems.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.stepBaggageAndPersonalItems.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.stepBaggageAndPersonalItems.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.stepBaggageAndPersonalItems.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  claimed: {
    id: 'fastCover.stepBaggageAndPersonalItems.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.stepBaggageAndPersonalItems.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepBaggageAndPersonalItems.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.stepBaggageAndPersonalItems.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.stepBaggageAndPersonalItems.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.stepBaggageAndPersonalItems.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.stepBaggageAndPersonalItems.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.stepBaggageAndPersonalItems.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.stepBaggageAndPersonalItems.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.stepBaggageAndPersonalItems.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.stepBaggageAndPersonalItems.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.stepBaggageAndPersonalItems.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.stepBaggageAndPersonalItems.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.stepBaggageAndPersonalItems.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.stepBaggageAndPersonalItems.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.medicalExpenseZurichStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  illnessStartDate: {
    id: 'fastCover.medicalExpenseZurichStep.illnessStartDate',
    defaultMessage: 'Illness Start Date',
  },
  isTheClaimTheResultYes: {
    id: 'fastCover.medicalExpenseZurichStep.isTheClaimTheResultYes',
    defaultMessage: 'If yes, was this a',
  },
  recreationalSport: {
    id: 'fastCover.medicalExpenseZurichStep.recreationalSport',
    defaultMessage: 'Recreational Sport',
  },
  professionalSpot: {
    id: 'fastCover.medicalExpenseZurichStep.professionalSport',
    defaultMessage: 'Professional Sport',
  },
  club: {
    id: 'fastCover.medicalExpenseZurichStep.club',
    defaultMessage: 'Club',
  },
  highSchoolSport: {
    id: 'fastCover.medicalExpenseZurichStep.highSchoolSport',
    defaultMessage: 'High School Sport',
  },
  ifYesForTheCollengiateSportsProgram: {
    id: 'fastCover.medicalExpenseZurichStep.ifYesForTheCollengiateSportsProgram',
    defaultMessage: 'If yes for the collengiate Sports Program, was this',
  },
  intramuralSports: {
    id: 'fastCover.medicalExpenseZurichStep.intramuralSports',
    defaultMessage: 'Intramural Sports (Sport organized within a particular educational institution)',
  },
  interCollegiateSports: {
    id: 'fastCover.medicalExpenseZurichStep.interCollegiateSports',
    defaultMessage: 'Intercollegiate sports (Sport or Activites between different colleges or schools)',
  },
  isTheClaimTheResultNo: {
    id: 'fastCover.medicalExpenseZurichStep.isTheClaimTheResultNo',
    defaultMessage: 'If no, was this a',
  },
  workRelated: {
    id: 'fastCover.medicalExpenseZurichStep.workRelated',
    defaultMessage: 'Work Related',
  },
  motorVehicleRelated: {
    id: 'fastCover.medicalExpenseZurichStep.motorVehicleRelated',
    defaultMessage: 'Motor Vehicle Related',
  },
  wasAnyotherPersonResponsibleForCausingYourAccident: {
    id: 'fastCover.medicalExpenseZurichStep.wasAnyotherPersonResponsibleForCausingYourAccident',
    defaultMessage: 'Was any other person responsible for causing your accident?',
  },
  ifYesPleaseExplain: {
    id: 'fastCover.medicalExpenseZurichStep.ifYesPleaseExplain',
    defaultMessage: 'If Yes, Please Explain',
  },
  wereYouUnderTheInfluenceOfDrugsOrAlclholAtTheTimeOfTheAcctident: {
    id: 'fastCover.medicalExpenseZurichStep.ifYesPleaseExplain',
    defaultMessage: 'Were you under the influence of drugs or alcohol at the time of the accident?',
  },
  wasTheAccidentOrInjuryTheResultOfAHazardousActivity: {
    id: 'fastCover.medicalExpenseZurichStep.wasTheAccidentOrInjuryTheResultOfAHazardousActivity',
    defaultMessage: 'Was the accident or injury the result of a hazardous activity?',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Zurich.MedicalExpense/messages.js